import { DayPicker, type DayPickerSingleProps, type DayPickerRangeProps } from 'react-day-picker';

type BaseProps = {
  className?: string;
};

type CalendarSingleProps = Omit<DayPickerSingleProps, 'mode'>;
export function CalendarSingle({ className = '', ...props }: BaseProps & CalendarSingleProps) {
  return (
    <DayPicker
      className={`rdp ${className}`}
      mode="single"
      weekStartsOn={1}
      showOutsideDays
      {...props}
    />
  );
}

type CalendarRangeProps = Omit<DayPickerRangeProps, 'mode'>;
export function CalendarRange({ className = '', ...props }: BaseProps & CalendarRangeProps) {
  return (
    <DayPicker
      className={`rdp ${className}`}
      mode="range"
      weekStartsOn={1}
      showOutsideDays
      numberOfMonths={2}
      {...props}
    />
  );
}
